/* eslint-disable sonarjs/no-duplicate-string */
// This file has global tailwind themes for formkit
// Created based on this link: https://dev.to/andrewboyd/creating-a-tailwind-css-theme-for-formkit-45o4

export const textClassification = {
  label:
    "block mb-1 font-semibold text-base formkit-invalid:text-platform-danger",
  inner:
    "border formkit-invalid:border-platform-danger mb-1 overflow-hidden focus-within:border-platform-border-2",
  input:
    "w-full h-10 px-3 border-none text-base text-platform-text-2 placeholder-platform-text-3",
};

const buttonClassification = {
  wrapper: "mb-1",
  input: "w-full py-4 px-2 base-button uppercase interaction-dark",
};

const inputClassification = {
  inner:
    "flex items-center base-input group-data-[invalid=true]/outer:border-platform-warning rounded",
  input: "border-none outline-none rounded",
  outer: "group/outer",
};

export const global = {
  help: "text-xs text-platform-text-2 mt-1",
  messages: "list-none p-0 mt-1 mb-0",
  message: "text-platform-warning mb-1 text-sm",
  input:
    "bg-platform-bg-1 text-platform-text-1 border py-4 px-4 w-full interaction-input",
  prefixIcon:
    "flex self-stretch grow-0 pl-4 shrink-0 [&>svg]:w-5 [&>svg]:m-auto",
};

// We'll export our definitions using our above
// classification templates and declare
// one-offs and overrides as needed.
export default {
  global,
  form: {
    form: "flex flex-col gap-y-4",
  },
  button: {
    ...buttonClassification,
  },
  submit: {
    ...buttonClassification,
    input: `${buttonClassification.input}`,
  },
  "family:box": {
    decorator:
      "block relative h-5 w-5 mr-2 bg-platform-bg-1 ring-1 ring-platform-border-1 peer-focus-within:ring-platform-border-2 peer-checked:ring-platform-border-2 text-transparent peer-checked:text-platform-text-1",
    decoratorIcon:
      "flex p-[3px] w-full h-full [&>svg]:w-full absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2",
    help: "mb-2 mt-1.5",
    input:
      "absolute w-0 h-0 overflow-hidden opacity-0 pointer-events-none peer",
    inner: "$remove:formkit-disabled:bg-gray-200",
    label: "$reset select-none",
    wrapper: "flex items-start mb-1",
  },
  autocomplete: {
    label: textClassification.label,
    input: "w-full p-2 border-none outline-none",
    inner:
      "relative flex items-center base-select group-data-[invalid=true]/outer:border-platform-warning",
    listboxButton:
      "w-8 p-2 self-stretch border-left shrink-0 interaction-white flex items-center justify-center",
    selectIcon: "w-4",
    dropdownWrapper: "top-0 mt-2 overflow-visible",
    listbox:
      "overflow-auto bg-platform-bg-1 text-platform-text-1 shadow border formkit-invalid:border-platform-danger py-1 focus-within:border-platform-border-2",
    emptyMessage: "p-2 text-sm text-platform-text-2",
    listitem:
      "flex aria-selected:bg-platform-color-1 aria-selected:text-platform-color-2 interaction-white",
    selectedIcon: "pl-2 mr-1 w-5 text-platform-text-3 h-full self-center",
    removeSelection:
      "flex text-platform-text-2 hover:text-platform-danger items-center justify-center h-full",
    closeIcon: "mx-2 w-3 h-full self-center",
    selection: "flex my-1 bg-platform-bg-2 cursor-move items-center text-sm",
    option: "inline-block w-full p-3 cursor-pointer text-sm",
    outer: "relative group/outer",
  },
  select: {
    inner:
      "flex relative items-center [&>span:first-child]:focus-within:text-platform-text-1",
    input:
      'w-full pl-3 pr-7 py-2 base-select text-base text-platform-text-1 placeholder-platform-text-2 formkit-multiple:p-0 data-[placeholder="true"]:text-[rgba(0,0,0,0.45)] formkit-multiple:data-[placeholder="true"]:text-inherit appearance-none rounded-sm',
    selectIcon:
      "flex p-[3px] shrink-0 w-5 -ml-[1.5em] h-full pointer-events-none [&>svg]:w-[1em]",
    option:
      "formkit-multiple:p-3 formkit-multiple:text-sm text-platform-text-1",
  },
  text: {
    ...inputClassification,
  },
  number: {
    ...inputClassification,
  },
  email: {
    ...inputClassification,
  },
  password: {
    ...inputClassification,
  },
  datepicker: {
    inner:
      "relative flex items-center border border-platform-border-1 formkit-invalid:border-error rounded-lg mb-1 focus-within:border-platform-border-2",
    panelWrapper:
      "absolute top-[calc(100%_+_0.5em)] shadow-[0_0_1.25em_rgba(0,0,0,.25)] rounded-md p-5 bg-white z-10",
    panelHeader:
      "grid grid-cols-[2.5em_1fr_2.5em] justify-center items-center border-b-2 mb-4 pb-4",
    input: "w-full border-none",
    label: textClassification.label,
    monthsHeader: "flex items-center justify-center col-start-2 col-end-2",
    timeHeader: "flex items-center justify-center col-start-2 col-end-2",
    overlayPlaceholder: "text-platform-text-2",
    months: "flex flex-wrap w-[20em]",
    month: `
      flex items-center justify-center
      w-[calc(33%_-_1em)] m-2 p-2 rounded-md
      bg-gray-200
      aria-selected:bg-blue-500 aria-selected:text-white
      focus:outline focus:outline-2 focus:outline-blue-500 focus:outline-offset-2 focus:bg-white focus:text-black
      data-[is-extra=true]:opacity-25
      formkit-disabled:opacity-50 formkit-disabled:cursor-default formkit-disabled:pointer-events-none
    `,
    yearsHeader: "flex items-center justify-center col-start-2 col-end-2",
    years: "flex flex-wrap w-[20em] max-w-[35em]",
    year: `
      flex items-center justify-center
      w-[calc(20%_-_1em)] m-2 p-2 rounded-md
      bg-gray-200
      aria-selected:bg-blue-500 aria-selected:text-white
      focus:outline focus:outline-2 focus:outline-blue-500 focus:outline-offset-2 focus:bg-white focus:text-black
      data-[is-extra=true]:opacity-25
      formkit-disabled:opacity-50 formkit-disabled:cursor-default formkit-disabled:pointer-events-none
    `,
    weekDays: "flex",
    weekDay:
      "flex w-[2.25em] h-[1em] m-1 items-center justify-center rounded-md font-normal lowercase",
    week: "flex formkit-disabled:opacity-50 formkit-disabled:cursor-default formkit-disabled:pointer-events-none",
    dayCell: `
      flex items-center justify-center
      w-[2.25em] h-[2.25em] m-1 p-2 rounded-md
      bg-gray-200
      aria-selected:bg-blue-500 aria-selected:text-white
      focus:outline focus:outline-2 focus:outline-blue-500 focus:outline-offset-2 focus:bg-white focus:text-black
      data-[is-extra=true]:opacity-25
      formkit-disabled:opacity-50 formkit-disabled:cursor-default formkit-disabled:pointer-events-none
    `,
    timeInput:
      "w-full border-2 border-gray-300 rounded-md p-2 my-[2em] focus-visible:outline-blue-500",
    daysHeader: "flex items-center justify-center",
    prev: "mr-auto px-3 py-1 hover:bg-gray-100 hover:rounded-lg col-start-1 col-end-1",
    prevLabel: "hidden",
    prevIcon: "flex w-3 select-none [&>svg]:w-full",
    dayButton:
      "appearance-none cursor-pointer px-3 py-1 border-2 rounded-lg mx-1 hover:border-blue-500",
    monthButton:
      "appearance-none cursor-pointer px-3 py-1 border-2 rounded-lg mx-1 hover:border-blue-500",
    yearButton:
      "appearance-none cursor-pointer px-3 py-1 border-2 rounded-lg mx-1 hover:border-blue-500",
    next: "ml-auto px-3 py-1 hover:bg-gray-100 hover:rounded col-start-3 col-end-3",
    nextLabel: "hidden",
    nextIcon: "flex w-3 select-none [&>svg]:w-full",
    openButton: `
      appearance-none border-0 bg-transparent flex p-0 self-stretch cursor-pointer
      focus-visible:outline-none focus-visible:text-white focus-visible:bg-blue-500
    `,
    calendarIcon:
      "flex w-8 grow-0 shrink-0 self-stretch select-none [&>svg]:w-full [&>svg]:m-auto [&>svg]:max-h-[1em] [&>svg]:max-w-[1em]",
  },
  file: {
    fileItem: "flex items-center text-gray-800 mb-1 last:mb-0",
    fileItemIcon: "w-4 mr-2 shrink-0",
    fileList:
      'shrink grow peer px-3 py-2 formkit-multiple:data-[has-multiple="true"]:mb-6',
    fileName: "break-all grow text-ellipsis",
    fileRemove:
      "relative z-[2] ml-auto text-[0px] hover:text-red-500 pl-2 peer-data-[has-multiple=true]:text-sm peer-data-[has-multiple=true]:text-blue-500 peer-data-[has-multiple=true]:ml-3 peer-data-[has-multiple=true]:mb-2 formkit-multiple:bottom-[0.15em] formkit-multiple:pl-0 formkit-multiple:ml-0 formkit-multiple:left-[1em] formkit-multiple:formkit-prefix-icon:left-[3.75em]",
    fileRemoveIcon: "block text-base w-3 relative z-[2]",
    inner:
      "relative max-w-md cursor-pointer formkit-multiple:[&>button]:absolute",
    input:
      "cursor-pointer text-transparent absolute top-0 right-0 left-0 bottom-0 opacity-0 z-[2]",
    noFiles: "flex w-full items-center px-3 py-2 text-gray-400",
    noFilesIcon: "w-4 mr-2",
  },
  repeater: {
    content: "grow py-3 flex flex-col align-center",
    controlLabel: "absolute opacity-0 pointer-events-none",
    controls: "flex flex-col items-center justify-center bg-gray-100 p-3",
    downControl:
      "hover:text-blue-500 disabled:hover:text-inherit disabled:opacity-25",
    help: "mb-2 mt-1.5",
    item: "w-full mb-1 rounded border border-gray-200",
    moveDownIcon: "block w-3 my-1",
    moveUpIcon: "block w-3 my-1",
    removeControl:
      "hover:text-blue-500 disabled:hover:text-inherit disabled:opacity-25",
    removeIcon: "block w-5 my-1",
    upControl:
      "hover:text-blue-500 disabled:hover:text-inherit disabled:opacity-25",
  },
  checkbox: {
    decorator: "$reset hidden",
    input: "$reset w-5 h-5 base-checkbox mr-2 bg-white rounded-sm",
    label: "cursor-pointer",
    wrapper: "flex items-center mb-1",
  },
  radio: {
    decorator: "$reset hidden",
    input: "$reset w-5 h-5 base-radio mr-2 bg-white",
  },
  slider: {
    outer:
      "group flex-grow min-w-0 text-base mb-4 data-[disabled]:select-none data-[disabled]:opacity-50 data-[disabled]:pointer-events-none",
    wrapper: "mb-1.5",
    label: "block text-platform-text-1 text-sm mb-1",
    help: "text-platform-text-2 text-xs mb-1",
    prefixIcon:
      "flex shrink-0 items-center -ml-1 mr-2 text-base h-[1em] w-[1em] [&>svg]:w-full text-platform-text-3",
    suffixIcon:
      "flex items-center -mr-1 ml-2 text-base h-[1em] w-[1em] shrink-0 [&>svg]:w-full text-platform-text-3",
    sliderInner:
      "flex items-center [&>[data-type=number]]:mb-0 [&>[data-type=number]]:ml-3 [&>[data-type=number]]:shrink [&>[data-type=number]]:grow-0 [&[data-has-mark-labels=true]_[id^=track]]:mb-3",
    track: "grow relative z-20 py-2.5 select-none",
    chart:
      "relative w-full flex items-center justify-between aspect-[3/1] mb-2 z-20",
    chartBar:
      "absolute bottom-0 h-full bg-platform-bg-3 data-[active=true]:bg-platform-text-1",
    trackWrapper: "rounded-none bg-platform-bg-2 px-1",
    trackInner: "relative h-1.5",
    fill: "h-full rounded-none absolute top-0 -mx-1 bg-platform-text-1",
    marks: "absolute pointer-events-none inset-0",
    mark: "absolute top-1/2 w-[3px] h-[3px] rounded-full -translate-x-1/2 -translate-y-1/2 bg-platform-text-1 data-[active=true]:bg-white",
    markLabel:
      "absolute top-[calc(100%+0.5em)] left-1/2 text-platform-text-1 text-xs -translate-x-1/2",
    handles: "",
    handle:
      "group/handle select-none w-4 h-4 rounded-full bg-white absolute top-1/2 left-0 z-30 -translate-x-1/2 -translate-y-1/2 border-2 border-platform-text-1 focus-visible:outline-0 focus-visible:ring-2 data-[is-target=true]:z-20",
    handleInner: "",
    tooltip:
      "absolute bottom-full left-1/2 -translate-x-1/2 -translate-y-[4px] bg-platform-text-1 text-white py-1 px-1.5 text-xs leading-none whitespace-nowrap rounded-none opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible/handle:opacity-100 group-data-[show-tooltip=true]/handle:opacity-100 after:content-[''] after:absolute after:top-full after:left-1/2 after:-translate-x-1/2 after:-translate-y-[1px] after:border-4 after:border-transparent after:border-t-platform-text-1",
    linkedValues: "flex items-start justify-between",
    minValue:
      "relative grow !max-w-[45%] mb-0 [&>div::after]:content-[''] [&>div::after]:absolute [&>div::after]:top-1/2 [&>div::after]:left-[105%] [&>div::after]:-translate-y-1/2 [&>div::after]:w-[12%] [&>div::after]:h-[1px] [&>div::after]:bg-platform-text-1",
    maxValue: "relative grow !max-w-[45%] mb-0",
    messages: "",
    message: "text-platform-danger mb-1.5 text-xs",
  },
  toggle: {
    outer:
      "group flex-grow min-w-0 text-base mb-4 data-[disabled]:select-none data-[disabled]:opacity-50 data-[disabled]:pointer-events-none max-w-none",
    wrapper: "flex flex-wrap items-center mb-1 justify-between",
    altLabel: "block w-full mb-1.5 text-xs text-platform-text-1",
    inner: "inline-block mr-2 order-2 cursor-pointer",
    input:
      "appearance-none outline-none placeholder:text-platform-text-3 peer absolute opacity-0 w-0 h-0",
    track:
      "relative min-w-[3em] will-change-transform p-0.5 select-none rounded-full transition-none bg-platform-bg-3 peer-focus-visible:ring-2 peer-checked:bg-platform-color-1 peer-checked:[&>div:last-child]:left-full peer-checked:[&>div:last-child]:-translate-x-full peer-checked:[&>div:first-child:not(:last-child)]:left-0 peer-checked:[&>div:first-child:not(:last-child)]:translate-x-0",
    thumb:
      "relative w-[50%] aspect-[1/1] p-0.5 left-0 rounded-full transition-none bg-platform-bg-1 text-platform-text-1",
    thumbIcon: "",
    valueLabel: "font-bold text-xs text-platform-text-1",
    label:
      "block text-platform-text-1 text-base mb-1 peer-first:mb-0 order-1 cursor-pointer",
    help: "text-platform-text-2 text-xs",
    messages: "",
    message: "text-platform-danger mb-1.5 text-xs",
  },
};
